// extracted by mini-css-extract-plugin
module.exports = {"columna":"columna_columna__VW_vF","regular-horizontal":"columna_regular-horizontal__sJW1H","mb-500":"columna_mb-500__pEd_e","slider":"columna_slider__7Yeav"};